import { SpectrumColor } from '../types';

export const Yellow: SpectrumColor = {
  0: '#FFF8EB',
  5: '#FFF3DA',
  10: '#FFEBC3',
  15: '#FFE5B0',
  20: '#FFDE9D',
  25: '#FDD78C',
  30: '#FBCF7A',
  35: '#FBC65E',
  40: '#FBBD41',
  50: '#FCB526',
  60: '#FFAA00',
  70: '#B97D01',
  80: '#8F5F00',
  90: '#795000',
  100: '#573A00',
  110: '#412C00',
  default: 60,
};
